import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SERVER_BASE_URL } from './constants';
import LogoComponent from './login/LogoComponent';
import ImageComponent from './login/ImageComponent';

import './MainPage.css'; // 추가된 부분

const MainPage = () => {
    const navigate = useNavigate();
    const apiKey = process.env.REACT_APP_X_API_KEY;
    const [isLoading, setLoading] = useState(false); // 로딩 상태 추가

    const handleDeleteData = () => {
        const token = localStorage.getItem('authorization_token');
        if (!token) {
            console.error('No authorization token found');
            return;
        }

        // 경고 메시지 표시 및 확인 시 삭제 진행
        if (window.confirm('Are you sure you want to delete your data? This action cannot be undone.')) {
            setLoading(true); // 로딩 시작

            fetch(`${SERVER_BASE_URL}/usage-info`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey,
                    'Authorization': `${token}`,
                    'authorization_token': `${token}`
                }
            })
                .then(response => {
                    setLoading(false); // 로딩 종료

                    if (response.status === 204) {
                        alert('Your data has been successfully deleted. Thank you.');
                        localStorage.removeItem('authorization_token');
                        navigate('/')
                    } else {
                        throw new Error('Failed to delete data');
                    }
                })
                .catch(error => {
                    setLoading(false); // 로딩 종료
                    console.error('Error:', error);
                    alert('Failed to delete data.');
                });
        }
    };

    const handleDeleteAccount = () => {
        const token = localStorage.getItem('authorization_token');
        if (!token) {
            console.error('No authorization token found');
            return;
        }

        // 경고 메시지 표시 및 확인 시 삭제 진행
        if (window.confirm('Are you sure you want to delete your account? This action cannot be undone.')) {
            setLoading(true); // 로딩 시작

            fetch(`${SERVER_BASE_URL}/user-info`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey,
                    'Authorization': `${token}`,
                    'authorization_token': `${token}`
                }
            })
                .then(response => {
                    setLoading(false); // 로딩 종료

                    if (response.status === 204) {
                        alert('Your account has been successfully deleted. Thank you.');
                        localStorage.removeItem('authorization_token');
                        navigate('/')
                    } else {
                        throw new Error('Failed to delete account');
                    }
                })
                .catch(error => {
                    setLoading(false); // 로딩 종료
                    console.error('Error:', error);
                    alert('Failed to delete account.');
                });
        }
    };

    return (
        <div className="parent-container">
            <LogoComponent></LogoComponent>
            <ImageComponent src="https://taki-bucket-1-1-0.s3.ap-northeast-2.amazonaws.com/data-msg.png" alt='img'></ImageComponent>
            <button className="delete-button" onClick={handleDeleteData}>Delete Data</button>
            <button className="delete-account-button" onClick={handleDeleteAccount}>Delete Account</button>

            {/* 로딩 상태에 따라 화면 어둡게 처리 */}
            {isLoading && <div className="loading-overlay"></div>}
        </div>
    );
};

export default MainPage;
